import { ArrowRight, Lightbulb, PauseCircle, Sparkles, Mountain } from "lucide-react";
import { JourneyMap } from "./JourneyMap";
import { STOPS } from "./journey";

const CHEER = ["Great start.", "Nearly halfway there.", "More than halfway there.", "Just one stop to go."];
const btn = "ds-btn min-h-[52px]";

export function WelcomeScreen({ name, onStart }) {
  return (
    <div className="rounded-[24px] bg-white border border-ds-plum/10 p-6 sm:p-10 rise" data-testid="journey-welcome">
      <Mountain className="h-9 w-9 text-ds-amber" />
      <h1 className="mt-4 font-display text-3xl sm:text-4xl font-semibold text-ds-plumdeep">{name ? `Ready for the journey, ${name}?` : "Ready for the journey?"}</h1>
      <div className="mt-6"><JourneyMap completed={0} current={0} /></div>
      <ul className="mt-6 space-y-3 text-ds-ink">
        <li>Your journey has <b>5 stops</b>, with <b>20 questions</b> at each stop.</li>
        <li>There are <b>no right or wrong answers</b>. Just pick what feels most like you.</li>
        <li>You can <b>pause anytime</b>. Every answer is saved automatically, so you can come back later and carry on from the same question.</li>
      </ul>
      <button onClick={onStart} className={`${btn} mt-8 w-full sm:w-auto bg-ds-plum text-white hover:bg-[#3d0232]`} data-testid="journey-welcome-start-button">Start at {STOPS[0]}<ArrowRight className="h-4 w-4" /></button>
    </div>
  );
}

export function BreakScreen({ stop, fact, onContinue, onPause, onReview }) {
  return (
    <div className="rounded-[24px] bg-white border border-ds-plum/10 p-6 sm:p-10 rise" data-testid="journey-break-screen">
      <JourneyMap completed={stop + 1} current={stop + 1} />
      <p className="mt-8 text-sm font-semibold text-ds-plum">Stop {stop + 1} of 5</p>
      <h1 className="mt-2 font-display text-3xl sm:text-4xl font-semibold text-ds-plumdeep" data-testid="journey-break-title">{STOPS[stop]} complete</h1>
      <p className="mt-2 text-ds-inksoft" data-testid="journey-break-encouragement">{CHEER[stop]} There are no right or wrong answers. Take a breath; {STOPS[stop + 1]} is next.</p>
      <div className="mt-6 rounded-2xl bg-ds-creamalt border border-ds-amber/30 p-5" data-testid="journey-fun-fact">
        <p className="flex items-center gap-2 text-sm font-bold text-ds-plumdeep"><Lightbulb className="h-4 w-4" />Career fun fact</p>
        <p className="mt-2 text-ds-ink leading-relaxed">{fact}</p>
      </div>
      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        <button onClick={onContinue} className={`${btn} bg-ds-plum text-white hover:bg-[#3d0232]`} data-testid="journey-continue-button">Continue to {STOPS[stop + 1]}<ArrowRight className="h-4 w-4" /></button>
        <button onClick={onPause} className={`${btn} border border-ds-plum/15 bg-white text-ds-plum hover:bg-ds-plum/5`} data-testid="journey-break-pause-button"><PauseCircle className="h-4 w-4" />Pause and come back later</button>
      </div>
      <p className="mt-4 text-xs text-center text-ds-inksoft">Continuing locks your {STOPS[stop]} answers. <button onClick={onReview} className="font-semibold text-ds-plum underline" data-testid="journey-review-stop-button">Review them first</button></p>
    </div>
  );
}

export function SummitScreen({ onSubmit, onReview, submitting }) {
  return (
    <div className="rounded-[24px] bg-white border border-ds-plum/10 p-6 sm:p-10 rise text-center" data-testid="journey-summit-screen">
      <JourneyMap completed={5} current={5} />
      <Sparkles className="mx-auto mt-8 h-10 w-10 text-ds-amber stop-pop" />
      <h1 className="mt-3 font-display text-3xl sm:text-4xl font-semibold text-ds-plumdeep">You reached the Summit!</h1>
      <p className="mt-3 text-ds-inksoft max-w-md mx-auto">You answered all 100 questions. Well done for being thoughtful and honest. Submit your answers and we will prepare the report.</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <button onClick={onSubmit} disabled={submitting} className={`${btn} bg-ds-plum text-white hover:bg-[#3d0232] disabled:opacity-60`} data-testid="assessment-submit-button">Submit answers</button>
        <button onClick={onReview} className={`${btn} border border-ds-plum/15 bg-white text-ds-plum hover:bg-ds-plum/5`} data-testid="journey-summit-review-button">Review Summit answers</button>
      </div>
    </div>
  );
}
